import React, {useState, useEffect, useContext} from 'react';
import {
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Button,
    InputGroup,
    Input,
    FormGroup,
    Label,
    CustomInput,
} from 'reactstrap';
import {editUser} from 'utils/api';
import {toast} from 'react-toastify';
import {connect} from 'react-redux';
import {ErrorContext} from 'contexts/ErrorContext';
import InputWithError from 'components/InputWithError';
import SpinnerButton from 'components/SpinnerButton';

const EditUserModal = ({isOpen, toggle, user, refreshList, auth, disableAdminSelection}) => {
    const {handleErrors} = useContext(ErrorContext);

    const [submitting, setSubmitting] = useState(false);
    const [isEmailEditingOpen, setIsEmailEditingOpen] = useState(false);
    const [newEmail, setNewEmail] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setName(user.name);
        setEmail(user.email);
        setIsAdmin(user.isAdministrator);
    }, [user]);

    const onConfirm = async() => {
        try {
            setSubmitting(true);
            const params = {
                name,
                email: newEmail.trim() ? newEmail : email,
                isAdministrator: isAdmin,
            };
            await editUser(user.id, params);
            // let isSwitchedToAdmin = isAdmin !== user.isAdministrator && isAdmin;
            refreshList(true);
            toast.success('User successfully updated');
            toggle();
        } catch(err) {
            setSubmitting(false);
            // if(err.message && err.message.length < 150) {
            //     toast.error(err.message);
            // }
            handleErrors(err, setError);
            console.log(err);
            // throw err;
        }
    };


    const toggleCheckbox = () => setIsAdmin(prevState => !prevState);

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader toggle={toggle}>
                <strong>Edit User</strong>
                <div>
                    {user.name}
                </div>
            </ModalHeader>
            <ModalBody>
                <InputWithError
                    placeholder="Full name"
                    name="name"
                    value={name}
                    type="text"
                    onChange={setName}
                    errorObj={error}
                    prependIcon={<i className="fas fa-user"/>}
                    marginBottomClass="mb-3"
                />
                <InputWithError
                    placeholder="Email"
                    name="disabledEmail"
                    value={email}
                    type="email"
                    onChange={setEmail}
                    errorObj={error}
                    disabled
                    prependIcon={<i className="fas fa-at"/>}
                    marginBottomClass="mb-3"
                />
                <div className="d-flex align-items-center mb-2">
                    <FormGroup className="custom-form-checkbox" check style={{marginRight: '1.5rem'}}>
                        <CustomInput
                            inline
                            type="checkbox"
                            name="isAdmin"
                            label="Administrator"
                            id="admin-checkbox"
                            disabled={disableAdminSelection}
                            onChange={toggleCheckbox}
                            checked={isAdmin}
                        />
                    </FormGroup>
                </div>
                {auth.username !== email &&
                <div
                    className="cursor-pointer mb-3 d-inline-block"
                    onClick={() => setIsEmailEditingOpen(prevState => !prevState)}
                >
                    <i
                        className="fas fa-pencil-alt mr-2"
                        title="Edit Email"
                        // style={{position: 'absolute', right: '-30px', fontSize: '20px', cursor: 'pointer'}}
                    />
                    Change Email
                </div>
                }
                {/*<InputGroup>*/}
                {/*    <div className="input-group-prepend">*/}
                {/*        <span style={{ width: '40px' }} className="input-group-text">*/}
                {/*            <i className="fas fa-at" />*/}
                {/*        </span>*/}
                {/*    </div>*/}
                {/*    <Input */}
                {/*        type="email" */}
                {/*        placeholder="E-mail" */}
                {/*        value={email}*/}
                {/*        onChange={setEmail}*/}
                {/*        disabled*/}
                {/*    />*/}
                {/*    {auth.username !== email &&*/}
                {/*        <div style={{ display: 'flex', alignItems: 'center' }}>*/}
                {/*            <i */}
                {/*                onClick={() => setIsEmailEditingOpen(prevState => !prevState)} */}
                {/*                className="fas fa-pencil-alt" */}
                {/*                title="Edit Email" */}
                {/*                style={{ position: 'absolute', right: '-30px', fontSize: '20px', cursor: 'pointer' }}*/}
                {/*            />*/}
                {/*        </div>*/}
                {/*    }*/}
                {/*</InputGroup>*/}
                {isEmailEditingOpen &&
                <InputWithError
                    placeholder="New email"
                    name="email"
                    value={newEmail}
                    type="email"
                    onChange={setNewEmail}
                    errorObj={error}
                    prependIcon={<i className="fas fa-at"/>}
                    marginBottomClass="mb-3"
                />

                    // <InputGroup className="user-edit-input_group">
                    //     <div className="input-group-prepend">
                    //             <span style={{width: '40px'}} className="input-group-text">
                    //                 <i className="fas fa-at"/>
                    //             </span>
                    //     </div>
                    //     <Input
                    //         type="email"
                    //         placeholder="New email"
                    //         value={newEmail}
                    //         onChange={(e) => setNewEmail(e.target.value)}
                    //     />
                    // </InputGroup>
                }

            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                {/*{creationLoading ?*/}
                {/*    <div className="flex-centered" style={{ width: '85px', height: '100%' }}>*/}
                {/*        <i className="fa fa-spinner fa-spin" />*/}
                {/*    </div>*/}
                {/*    :*/}
                {/*    <Button */}
                {/*        style={{ minWidth: '85px' }} */}
                {/*        onClick={onConfirm} */}
                {/*        className="calltoaction-button"*/}
                {/*        disabled={!userData.name.trim()}*/}
                {/*    >*/}
                {/*        Save Changes*/}
                {/*    </Button>*/}
                {/*}*/}
                <SpinnerButton
                    minWidth="123.22px"
                    title="Save Changes"
                    onClick={onConfirm}
                    submitting={submitting}
                />
                {/*<Button*/}
                {/*    className="calltoaction-button"*/}
                {/*    style={{minWidth: '85px'}}*/}
                {/*    onClick={onConfirm}*/}
                {/*    // disabled={!inputValue.trim() || previewLoading}*/}
                {/*>*/}
                {/*    {creationLoading ?*/}
                {/*        <div className="flex-centered">*/}
                {/*            <i className="fa fa-spinner fa-spin"/>*/}
                {/*        </div>*/}
                {/*        :*/}
                {/*        <>Save Changes</>*/}
                {/*    }*/}
                {/*</Button>*/}
            </ModalFooter>
        </Modal>
    );
};

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(EditUserModal);